import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const ImageBand = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} data-testid="image-band" className="relative h-[52vh] md:h-[70vh] overflow-hidden">
      <motion.img
        src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1600&q=80"
        alt="Lavoratori in cantiere con dispositivi di protezione — prevenzione e medicina del lavoro"
        style={{ y }}
        className="absolute inset-0 h-[125%] w-full object-cover"
      />
      <div className="absolute inset-0 bg-ink/55" />
      <div className="relative z-10 flex h-full items-center justify-center px-5">
        <p className="font-display text-3xl md:text-5xl leading-tight text-white text-center max-w-4xl">
          "La salute non è tutto, ma senza salute tutto è niente"
        </p>
      </div>
    </section>
  );
};
